import { MainIcon } from "../../helper/MainIcon";

function LogoBaladz() {
    return (
        <>
            <table>
                <tbody>
                    <tr>
                        <td>
                            <img style={{ height: "50px" }} src={MainIcon.MainLogo()}></img>
                        </td>
                    </tr>
                </tbody>
            </table>
        </>
    )
}

export default LogoBaladz;